import { lockScroll, unlockScroll } from '@shared/helpers/scroll';
import { generateUUID } from '@shared/utils/uuid';

declare global {
    interface Window {
        dialogStack: DialogEntry[];
        _dialogEscapeHandlerAttached?: boolean;
    }
}

type DialogOptions = {
    lockBody?: boolean;
    onEscClose?: () => void;
};

type DialogEntry = {
    id: string;
    lockBody: boolean;
    onEscClose: () => void;
};

window.dialogStack = window.dialogStack ?? [];

export function useDialogManager() {
    const id = generateUUID();

    function register(options: DialogOptions) {
        const entry: DialogEntry = {
            id,
            lockBody: options.lockBody ?? false,
            onEscClose: options.onEscClose ?? (() => {}),
        };

        window.dialogStack.push(entry);

        if (entry.lockBody) {
            lockScroll();
        }
    }

    function unregister() {
        const index = window.dialogStack.findIndex((m) => m.id === id);
        if (index !== -1) window.dialogStack.splice(index, 1);

        if (!window.dialogStack.some((m) => m.lockBody)) {
            unlockScroll();
        }
    }

    function getActiveDialog(): DialogEntry | undefined {
        return window.dialogStack[window.dialogStack.length - 1];
    }

    function handleEscape(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            const active = getActiveDialog();
            active && active.onEscClose();
        }
    }

    if (!window._dialogEscapeHandlerAttached) {
        window.addEventListener('keyup', handleEscape);
        window._dialogEscapeHandlerAttached = true;
    }

    return {
        register,
        unregister,
    };
}
